import React, { createContext, useReducer, useContext } from "react";

const initialState = {
  user: null,
  booking: null,
  ui: { offline: false },
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "CLEAR_USER":
      return { ...state, user: null, booking: null };
    case "START_BOOKING":
      return { ...state, booking: action.payload };
    case "CANCEL_BOOKING":
      return { ...state, booking: null };
    case "SET_OFFLINE":
      return { ...state, ui: { ...state.ui, offline: action.payload } };
    default:
      return state;
  }
}

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
